var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('StreamBarcodeReader',{on:{"decode":(a, b, c) => _vm.onDecode(a, b, c),"loaded":() => _vm.onLoaded()}}),_vm._v(" Input Value: "+_vm._s(_vm.text || "Nothing")+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }